import type { StudentClaim } from "@/api/studentClaims";
import type { User } from "@/js/utils/userUtils";
import { i18nInstance } from "@/i18n";

export type StudentClaimBannerViewModel = {
	show: boolean;
	tooltipLabel: string;
};

/**
 * Whether to show the student-tile "Claim Student" banner for this user, and the tooltip copy.
 * Aligns with `sortRegularClassroomStudents` / other-class claims: requires `qoriaUserId`, active class,
 * a claim row with `teacherName`, and claim not for the current classroom.
 */
export function getStudentClaimBannerViewModel(
	user: User,
	classIsActive: boolean,
	classroomStableIdV1: string,
	claimsByStudentId: Record<string, StudentClaim>
): StudentClaimBannerViewModel {
	const qid = user.qoriaUserId ?? "";
	if (!qid || !classIsActive) {
		return { show: false, tooltipLabel: "" };
	}
	const claim = claimsByStudentId[qid];
	if (!claim?.teacherName) {
		return { show: false, tooltipLabel: "" };
	}
	if (claim.classId === classroomStableIdV1) {
		return { show: false, tooltipLabel: "" };
	}
	return {
		show: true,
		tooltipLabel: i18nInstance.t("classroomDetails.selectToClaimManagementFrom", { teacherName: claim.teacherName }),
	};
}
